import React, { useState } from 'react';
function MenuBar({ visualizerMode, setVisualizerMode }) {
    const [fileMenuOpen, setFileMenuOpen] = useState(false);
    const [vizMenuOpen, setVizMenuOpen] = useState(false);
    const toggleFileMenu = () => {
        setFileMenuOpen(prev => !prev);
    };
    const toggleVizMenu = () => {
        setVizMenuOpen(prev => !prev);
    };
    const handleExit = () => {
        window.close();
    };
    const modes = [
        { label: 'Waveform', value: 'waveform' },
        { label: 'Spectrum', value: 'spectrum' },
        { label: 'Radial', value: 'radial' },
        { label: 'Particle', value: 'particle' },
        { label: 'Tunnel', value: 'tunnel' },
    ];
    return (React.createElement("div", null,
        React.createElement("nav", { className: "bg-gray-800 text-white px-4 py-2 border-b border-gray-700 relative z-50" },
            React.createElement("ul", { className: "flex space-x-6" },
                React.createElement("li", { className: "cursor-pointer hover:underline relative", onClick: toggleFileMenu },
                    "File",
                    fileMenuOpen && (React.createElement("ul", { className: "absolute bg-gray-800 text-white mt-2 py-2 w-32 border border-gray-700" },
                        React.createElement("li", { className: "px-4 py-2 hover:bg-gray-700 cursor-pointer" }, "Save"),
                        React.createElement("li", { className: "px-4 py-2 hover:bg-gray-700 cursor-pointer" }, "Open"),
                        React.createElement("li", { className: "px-4 py-2 hover:bg-gray-700 cursor-pointer", onClick: handleExit }, "Exit")))),
                React.createElement("li", { className: "cursor-pointer hover:underline" }, "Edit"),
                React.createElement("li", { className: "cursor-pointer hover:underline" }, "View"),
                React.createElement("li", { className: "cursor-pointer hover:underline" }, "Window"),
                React.createElement("li", { className: "cursor-pointer hover:underline relative", onClick: toggleVizMenu },
                    "Visualizer",
                    vizMenuOpen && (React.createElement("ul", { className: "absolute bg-gray-800 text-white mt-2 py-2 w-40 border border-gray-700" }, modes.map(modeOpt => (React.createElement("li", { key: modeOpt.value, className: `px-4 py-2 hover:bg-gray-700 cursor-pointer ${visualizerMode === modeOpt.value ? 'bg-gray-700' : ''}`, onClick: () => { setVisualizerMode(modeOpt.value); setVizMenuOpen(false); } }, modeOpt.label))))))))));
}
export default MenuBar;
